import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PreviewImage } from '@plone/volto/components';

import { itemTags } from './utils';

const iconThemes = [
  {
    match: /英語|ORT|English/i,
    className: 'english',
  },
  {
    match: /図書館|本棚|貸出/,
    className: 'library',
  },
  {
    match: /家庭学習|そろばん|学習|勉強/,
    className: 'study',
  },
  {
    match: /読み聞かせ|絵本|読書|本/,
    className: 'reading',
  },
  {
    match: /娘|お気に入り|好き/,
    className: 'favorite',
  },
];

const fallbackIcon = (item) => {
  const source = [item?.title, ...(itemTags(item) || [])].filter(Boolean).join(' ');
  return (
    iconThemes.find((theme) => theme.match.test(source)) || {
      className: 'book',
    }
  );
};

const generatedIconUrl = (item, variant) => {
  const params = new URLSearchParams();
  const title = item?.title || item?.Title || '';
  const description = item?.description || item?.Description || '';
  const tags = itemTags(item).join(', ');

  params.set('size', variant === 'hero' ? 'hero' : 'list');
  if (title) params.set('title', title);
  if (description) params.set('description', description);
  if (tags) params.set('tags', tags);

  return `/++api++/@article-icon?${params.toString()}`;
};

const ArticleIcon = ({ item, variant = 'list' }) => {
  const [generatedFailed, setGeneratedFailed] = useState(false);
  const hasPreview = Boolean(item?.image_field);

  if (hasPreview) {
    return (
      <div className={`ehon-article-icon ehon-article-icon-${variant}`}>
        <PreviewImage item={item} size={variant === 'hero' ? 'large' : 'thumb'} alt="" />
      </div>
    );
  }

  const icon = fallbackIcon(item);
  const iconUrl = generatedIconUrl(item, variant);

  if (!generatedFailed && iconUrl) {
    return (
      <div className={`ehon-article-icon ehon-article-icon-${variant}`}>
        <img
          alt=""
          loading="lazy"
          src={iconUrl}
          onError={() => setGeneratedFailed(true)}
        />
      </div>
    );
  }

  return (
    <div
      aria-hidden="true"
      className={`ehon-article-icon ehon-article-icon-${variant} ehon-article-icon-placeholder ehon-article-icon-${icon.className}`}
    />
  );
};

ArticleIcon.propTypes = {
  item: PropTypes.shape({
    image_field: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    Subject: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  variant: PropTypes.oneOf(['hero', 'list']),
};

export default ArticleIcon;
